<template>
  <footer class="bg-dark-blue text-white text-center md:text-left w-full">
    <div
      class="flex flex-col-reverse md:flex-row p-3 py-12 gap-0 md:gap-8 lg:gap-20 xl:gap-32 2xl:gap-36 md:max-w-[95%] xl:max-w-6xl 2xl:max-w-7xl mx-auto"
    >
      <div
        class="FooterBranding flex flex-col gap-4 items-center md:items-start"
      >
        <JoszakiLogo sizing="footer" />
        <div class="flex">
          <LogoSocial
            v-for="network in socialNetworkUrls"
            :key="network.type"
            :url="network.url"
            :label="network.label"
            :icon="network.icon"
          />
        </div>
        <div
          v-if="$branding.isJoszaki"
          class="flex flex-row flex-wrap justify-center md:justify-start gap-2"
        >
          <div class="rounded bg-white p-2">
            <img
              v-lazy-load data-src="~/assets/logos/barion-banner.svg"
              alt="Barion - elfogadott bankkártyák"
              class="h-7 w-auto"
              loading="lazy"
            />
          </div>
          <a
            href="http://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf"
            target="_blank"
            rel="noopener"
            class="rounded bg-white p-2"
          >
            <img
              v-lazy-load data-src="~/assets/simplepay_bankcard_logos_left.png"
              title="SimplePay - Online bankkártyás fizetés"
              alt="SimplePay vásárlói tájékoztató"
              class="h-7 w-auto"
              loading="lazy"
            />
          </a>
        </div>
      </div>
      <div :class="['flex-1 grid grid-cols-1 gap-4', gridColsClass]">
        <FooterLinksAbout v-if="showAbout" />
        <FooterLinksContent v-if="showContent" />
        <FooterLinksUseful v-if="showUseful" />
        <FooterLinksForMates v-if="showForMates" />
      </div>
    </div>
    <div class="bg-dark-blue-darker p-3 text-center">
      {{
        $t("footer.since", {currentYear: new Date().getFullYear()}),
      }}
    </div>
  </footer>
</template>

<script>
import { computed, useContext } from "@nuxtjs/composition-api";
import FooterLinksAbout from "./footer/FooterLinksAbout.vue";
import FooterLinksContent from "./footer/FooterLinksContent.vue";
import FooterLinksForMates from "./footer/FooterLinksForMates.vue";
import FooterLinksUseful from "./footer/FooterLinksUseful.vue";
import LogoSocial from "./footer/LogoSocial.vue";
import JoszakiLogo from "./img/JoszakiLogo.vue";

const COLS_CLASS_BY_COUNT = {
  1: "md:grid-cols-1",
  2: "md:grid-cols-2",
  3: "md:grid-cols-3",
  4: "md:grid-cols-4",
};

export default {
  components: {
    JoszakiLogo,
    LogoSocial,
    FooterLinksAbout,
    FooterLinksContent,
    FooterLinksUseful,
    FooterLinksForMates,
  },
  props: {
    showAbout: { type: Boolean, default: true },
    showContent: { type: Boolean, default: true },
    showUseful: { type: Boolean, default: true },
    showForMates: { type: Boolean, default: true },
  },
  setup(props) {
    const { $helpers } = useContext();
    const gridColsClass = computed(() => {
      const count = [
        props.showAbout,
        props.showContent,
        props.showUseful,
        props.showForMates,
      ].filter(Boolean).length;
      return COLS_CLASS_BY_COUNT[count] ?? "md:grid-cols-4";
    });
    return {
      socialNetworkUrls: $helpers.socialNetworkUrls,
      gridColsClass,
    };
  },
};
</script>
